module.exports = {
      id: "wind-banners-beach-flags-usage",
      viewBox: "0 0 255.3 584.3",
      url: __webpack_public_path__ + "img/icons.400d09d6.svg#wind-banners-beach-flags-usage",
      toString: function () {
        return this.url;
      }
    }